module.exports = __webpack_public_path__ + "img/members-icon.f5f97b26.svg";